import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterRoad, MapAdapterBoundingBox, useNetworksStateContext, useGetAvailableSubnetworkForModule } from "@l2r-front/l2r-networks"
import { useUrlParams, NavigateWithParams } from "@l2r-front/l2r-utils"

import { API_MODULE_MIRANDA, API_MODULE_ROADWAY } from "../../../../common/constants/appRoad"
import { RoadwayDetailSegmentSelectListener } from "../../containers/RoadwayDetailSegmentSelectListener"
import { RoadwayDetailSidebar } from "../../containers/RoadwayDetailSidebar"
import { RoadwaySidebar } from "../../containers/RoadwaySidebar"

export const RoadwayMobileRoutes = () => {
    const { getParams } = useUrlParams()
    const availableSubNetworksForRoadway = useGetAvailableSubnetworkForModule(API_MODULE_ROADWAY)?.length > 0
    const { selectedNetwork } = useNetworksStateContext()
    const roadwayAvailable = selectedNetwork.children?.length ? availableSubNetworksForRoadway : selectedNetwork?.modules?.includes(API_MODULE_ROADWAY)
    const availableSubNetworksForMiranda = useGetAvailableSubnetworkForModule(API_MODULE_MIRANDA)?.length > 0
    const mirandaAvailable = selectedNetwork.children?.length ? availableSubNetworksForMiranda : selectedNetwork?.modules?.includes(API_MODULE_MIRANDA)
    const currentModule = mirandaAvailable && !roadwayAvailable ? API_MODULE_MIRANDA : API_MODULE_ROADWAY

    const roadwayRoutes = useMemo(() => {
        const searchParams = getParams()

        return [
            {
                path: "/*",
                element:
                    <>
                        <MapAdapterBoundingBox module={currentModule} />
                        <SegmentSelectListener />
                        <RoadwaySidebar />
                    </>,
            },
            {
                path: "/:road",
                element:
                    <>
                        <MapAdapterRoad module={currentModule} />
                        <RoadwayDetailSegmentSelectListener />
                        <RoadwayDetailSidebar />
                    </>,
            },
            {
                path: "/:road/*",
                element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
            },
        ]
    }, [currentModule, getParams])

    return useRoutes(roadwayRoutes)
}